import React from 'react';
import { Box } from '@mui/material';

interface CodeBlockProps {
  code: string;
  language?: string; // optional if you want syntax highlighting later
}

const CodeBlock: React.FC<CodeBlockProps> = ({ code }) => {
  return (
    <Box
      component="pre"
      sx={{
        width: '700px',
        backgroundColor: '#1e1e1e',
        color: '#d4d4d4',
        fontSize: '0.875rem',
        padding: 2,
        marginBlock: 0,
        borderRadius: 2,
        overflowX: 'scroll',
        scrollbarWidth: 'thin',
        fontFamily: "Consolas, Monaco, 'Courier New', monospace"
      }}
    >
      <code>{code}</code>
    </Box>
  );
};

export default CodeBlock;
